/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container } from "reactstrap";

// core components

function Aamsfooter() {
  return (
    <>
      <footer className="footer footer-default">
        <Container>
          
          <div className="copyright" id="copyright">
            {/* © {new Date().getFullYear()}, Designed & {" "}
           
             Coded by{" "}
            <a
              href="/"
              target="_blank"
            >
             Noi Software
            </a>
            . */}
          </div>
        </Container>
      </footer>
    </>
  );
}

export default Aamsfooter;
